import { useCallback } from 'react'
import { useApolloClient } from 'react-apollo'
import { useDispatch } from 'react-redux'
import { enableLoadingOverlay, endLoadingOverlay } from '../actions'

/**
 * Creates an Apollo query function wrapped with the application's loading overlay.
 * An optional predicate treats unsuccessful query data as an error response.
 */
export function useQueryAndLoading(query) {
  const client = useApolloClient()
  const dispatch = useDispatch()

  return useCallback(async (operation, options, isResponseError = () => false) => {
    const key = new Date().getTime()
    dispatch(enableLoadingOverlay(key, operation))

    try {
      const result = await client.query({ query, ...options })
      if (isResponseError(result)) throw result

      dispatch(endLoadingOverlay(key, operation))
      return result
    } catch (error) {
      dispatch(endLoadingOverlay(key, operation, { error: true }))
      throw error
    }
  }, [client, dispatch, query])
}
